import React, { ReactNode } from 'react'

import { CommonTableColumnsEnum } from '../../components/Table/types'
import { PagePagination } from '../../types'
import { UserAccount } from '../../user'

export type LogHistory = {
  [CommonTableColumnsEnum.date]: string
  [CommonTableColumnsEnum.action]: string
  [CommonTableColumnsEnum.account]: string | null
  [CommonTableColumnsEnum.comment]: string | null
}

export type ImportHistory = {
  [CommonTableColumnsEnum.date]: string
  [CommonTableColumnsEnum.action]: string
  [CommonTableColumnsEnum.account]: string
  [CommonTableColumnsEnum.status]: boolean
  [CommonTableColumnsEnum.comment]: string | null
}

export interface LogHistoryData {
  data: LogHistory[]
  meta: PagePagination<LogHistory>
}

export interface ImportHistoryData {
  data: ImportHistory[]
  meta: PagePagination<ImportHistory>
}

export type SettingsState = {
  logHistory: {
    data: LogHistory[]
    pagination: PagePagination<LogHistory>
  }
  importHistory: {
    data: ImportHistory[]
    pagination: PagePagination<ImportHistory>
  }
}

export type AccountCardProps = {
  account: UserAccount | null
  selectedAccount: UserAccount | null
  eventType: AccountForm
  openEditModal?: () => void
  platforms?: Platform
}

export type RemoveAccountModalProps = {
  isOpen: boolean
  account: UserAccount
  closeModal: (isRemoved?: boolean) => void
}

export enum AccountForm {
  add = 'add',
  edit = 'edit',
}

export enum ImportTypeEnum {
  manual = 'Manual',
  autoSync = 'Auto Sync',
}

export type AccountSettingsFormProps = {
  type: AccountForm
  closeModal?: () => void
  editableAccount?: UserAccount | null
  openRemoveAccountModal?: () => void
  platforms: Platform
  onSuccess?: () => void
  withWrapper?: boolean
  withTitle?: boolean
  withCancel?: boolean
  submitButtonText?: ReactNode
  actions?: ReactNode
}

export type AccountTabProps = {
  addingNewAccount: boolean
  setAddingNewAccount: React.Dispatch<React.SetStateAction<boolean>>
  editableAccount: UserAccount | null
  setEditableAccount: React.Dispatch<React.SetStateAction<UserAccount | null>>
}

export type EditAccDTO = {
  id?: number
  name: string
  platform?: string
  // balance: number
  login?: string
  password?: string
  server?: string
  brokerId?: number
  importType?: ImportTypeEnum
  manualBrokerName?: string
}

export enum PlatformEnum {
  mt4 = 'Meta Trader 4',
  mt5 = 'Meta Trader 5',
  generic = 'Generic',
}

export type PlatformKeys = keyof typeof PlatformEnum

export type Platform = {
  [K in PlatformKeys]: (typeof PlatformEnum)[K]
}

export type ServersList = {
  company: string
  name: string
  isDemo: string
  access: string
}

export type ServerOption = { server: string; company: string }
